import { NgModule } from "@angular/core";
import { FooterComponent } from "./footer.component";
import { CommonModule } from "@angular/common";
import { I18nModule, UrlModule } from "@spartacus/core";
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule, MediaModule } from "@spartacus/storefront";
import { RouterModule } from "@angular/router";


@NgModule({
    imports: [
        CommonModule,
        PageLayoutModule,
        OutletModule,
        OutletRefModule,
        PageSlotModule,
        I18nModule,
        MediaModule,
        RouterModule,
        UrlModule
    ],
    providers: [],
    declarations: [FooterComponent]
})
export class FooterModule {

}
